import { request } from "../../../utils";

export const fetchWallets = async () => {
  const res = await request.get({
    url: "/wallet/balance"
  });
  return res.data;
};

export const createWallet = async (payload: any) => {
  const res = await request.post({
    url:"/wallet", 
    data: payload
   });
  return res.data;
};

export const requestBvnOTP = async (bvn: string): Promise<void> => {
  await request.post({
    url: "/utility/identity-verification",
    data: { type: "BVN", value: bvn },
  });
};

export const ListTransactions = async (params: string) => {
  try {
    const res = await request.get({ url: `/transactions?${params}` });
    return res.data;

  } catch (err) {
    throw err;
  }
};

export const ValidatePIN = async (pin: string) => {
  try {
    const { success } = await request.post({
      url: "/user/pin/validate",
      data: { pin },
    });
    return success;
  } catch ({ message }: any) {
    return false;
  }
};

export const changePin = async (oldPin: string, newPin: string) => {
  try {
    const { success } = await request.post({
      url: "/user/pin",
      data: { oldPin, pin: newPin, confirmPin: newPin },
    });
    return success;
  } catch ({ message }: any) {
    return false;
  }
};

export const fetchCountryConfig = async (iso2: string) => {
  try {
    const res = await request.get({
      url: `/utility/currency-config/${iso2}`,
    });
    
    if (res?.success && res.data) {
      return res.data;
    }
    return null;
  } catch (error) {
    console.error(`Error fetching config for ${iso2}:`, error);
    return null;
  }
};

export const fundWallet = async (fields: any) => {
  try {
    const res = await request.post({
      url: "/transaction/fund-wallet",
      data: fields
    })

    return res.data
  } catch (error) {
    console.error(`error funding wallet for ${fields.currency}`)
  }
}